module.exports = __webpack_public_path__ + "static/media/discord_button.983faaf7.png";